import {
    ACCESS_TKN_KEY,
    GRAPH_TOKEN,
    StorageService,
} from '../services/storage_service';
import { isJwtExpired } from './isJwtExpired.helper';
import { acquireAccessToken, acquireGraphToken, getActiveAccount } from '../auth/msal';

export const validateTokens = async () => {
    let accessToken = StorageService.getItem(ACCESS_TKN_KEY);
    let graphToken = StorageService.getItem(GRAPH_TOKEN);
    const activeAccount = getActiveAccount();
    const username = activeAccount?.username;

    if (!isJwtExpired(accessToken) && !isJwtExpired(graphToken)) {
        return {
            accessToken,
            graphToken,
        };
    }

    try {
        if (isJwtExpired(accessToken)) {
            if (!username) {
                throw new Error('no_active_account');
            }
            // request for new access token
            const tokenResponse: any = await acquireAccessToken(username);
            accessToken = tokenResponse.accessToken;
            StorageService.setItem(ACCESS_TKN_KEY, accessToken);
        }
        if (isJwtExpired(graphToken)) {
            if (!username) {
                throw new Error('no_active_account');
            }
            // request for new graph token
            const graphApiResponse: any = await acquireGraphToken(username);
            graphToken = graphApiResponse.accessToken;
            StorageService.setItem(GRAPH_TOKEN, graphToken);
        }

        return {
            accessToken,
            graphToken,
        };
    } catch (error: any) {
        if (error?.message === 'redirect_initiated' ||
            error?.errorCode === 'interaction_in_progress' ||
            error?.message === 'no_active_account') {
            throw error;
        }

        // Handle refresh token expiration
        if (error?.errorCode === 'invalid_grant' || 
            error?.message?.includes('AADSTS700084')) {
            
            // Clear all storage and redirect to login
            StorageService.clear();
            sessionStorage.clear();

            throw new Error('reauth_required');
        }
        throw error;
    }
};

export const isTokenExpired = () => {
    const accessToken = StorageService.getItem(ACCESS_TKN_KEY);
    const graphToken = StorageService.getItem(GRAPH_TOKEN);

    return isJwtExpired(accessToken) || isJwtExpired(graphToken);
}